import classes from './Container.module.css';
import Box from '@mui/material/Box';

const Container = (props: { children: JSX.Element | string | (JSX.Element | string)[], width?: string })  =>
{
  return (
    <section className={classes.container}>
      <Box sx={{ marginLeft: '40px', marginRight: '-20px', width: props.width || '100%' }}>
        {props.children}
      </Box>
    </section>);
};

export default Container;
